import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';

import { CoreText } from '../../../../base-ui/CoreText';
import { theme } from '../../../../theme/theme';

import type { ReactNode } from 'react';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${theme.paddings.lg};
`;

const UserNameSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${theme.paddings.sm};
`;

const UserNameRow = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`;

const SignOutButton = styled.button`
	border: none;
	background-color: transparent;
	border-radius: 20px;
	block-size: 20px;
	display: flex;
	flex-direction: row;
	align-items: center;
	padding-block: 12px;
	padding-inline: 13px;
	margin-inline-start: 25px;
	cursor: pointer;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
`;

export interface MainLayoutUserPreferencesProps {
	readonly userName: ReactNode;
	readonly showSignOut?: boolean;
	readonly onSignOut?: VoidFunction;
	readonly settings?: ReactNode;
}

export const MainLayoutUserPreferences = observer(function MainLayoutUserPreferences({
	userName,
	showSignOut = false,
	onSignOut,
	settings = null,
}: MainLayoutUserPreferencesProps) {
	return (
		<Container>
			<UserNameSection>
				<CoreText type='body1BoldUnderline'>User Name</CoreText>
				<UserNameRow>
					<CoreText type='body1Medium'>{userName}</CoreText>
					{showSignOut && (
						<SignOutButton type='button' onClick={onSignOut}>
							<CoreText type='captionHeader' text='Sign out' whiteSpace='nowrap' />
						</SignOutButton>
					)}
				</UserNameRow>
			</UserNameSection>
			{settings}
		</Container>
	);
});
